import './LandProductDetailPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ConfigProvider, Button, Space, Tag, List, Drawer, Image } from 'antd'
import zhCN from 'antd/es/locale/zh_CN' // 引入中文语言包
import { ArrowRightOutlined } from '@ant-design/icons'
import LandBottomLayout from '../common/LandBottomLayout'
import {
  products,
  getProductByPid,
  getVarietyByVid,
  getProductsOfVariety,
} from '../../products/ProductProvider'

export default class LandProductDetailPage extends React.Component {
  constructor(props) {
    super(props)
    const [pid, product, vid, variety, dataSource, initialPositionItem] =
      this.geInitialStateParams(this.props.location.search)
    this.state = {
      pid: pid,
      product: product,
      vid: vid,
      variety: variety,
      dataSource: dataSource,
      initialPositionItem: initialPositionItem,
    }
    this.productRefs = this.getProductRefs()
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps = async (nextProps) => {
    if (this.props.location.search !== nextProps.location.search) {
      const [pid, product, vid, variety, dataSource, initialPositionItem] =
        this.geInitialStateParams(nextProps.location.search)
      this.state = {
        pid: pid,
        product: product,
        vid: vid,
        variety: variety,
        dataSource: dataSource,
        initialPositionItem: initialPositionItem,
        listShown: false,
      }
      return true
    }
  }

  render() {
    return (
      <div>
        <div className="LandProductDetail">
          <div className="LandProductDetailQuickNav">
            <Button
              type="line"
              style={{
                marginLeft: 'auto',
                fontSize: 20,
                fontWeight: 'bold',
                textDecoration: 'underline',
                paddingTop: 10,
                paddingBottom: 10,
                fontFamily: 'MyCustomizedFont',
              }}
              icon={<ArrowRightOutlined />}
              iconPosition="end"
              onClick={() => {
                this.setState({ open: true }, () => {
                  if (!this.state.listShown) {
                    if (this.state.initialPositionItem) {
                      var ref = this.getProductRefByPid(
                        this.state.initialPositionItem.pid
                      )
                      if (ref.current) {
                        ref.current.scrollIntoView({})
                      }
                    }
                    this.setState({ listShown: true })
                  }
                })
              }}
            >
              {this.state.variety
                ? '快速查看所有' + this.state.variety.name
                : '快速查看所有产品'}
            </Button>
          </div>

          <div className="LandProductDetailProductWrapper">
            <div className="LandProductDetailText">
              {this.state.product.specialized ? (
                <Space size={'middle'}>
                  {this.state.product.specialized.map((tag) => {
                    return (
                      <Tag
                        color="#108ee9"
                        style={{
                          marginBottom: 20,
                          paddingLeft: 10,
                          paddingRight: 10,
                          paddingTop: 6,
                          paddingBottom: 6,
                          fontSize: 16,
                        }}
                      >
                        {tag}
                      </Tag>
                    )
                  })}
                </Space>
              ) : null}

              <div className="LandProductDetailName">
                {this.state.product.name}
              </div>

              <div className="LandProductDetailFeatureContent">
                <div className="LandProductDetailFeatureText">
                  {this.state.product.feature}
                </div>
              </div>

              {this.state.product.purchasable
                ? this.getCommonLinkButton()
                : this.getCommonConsultButton()}

              <div className="LandProductDetailPurchaseHint">
                {'*如需获取具体产品参数及文档，请联系商务或技术支持'}
              </div>
            </div>

            <img
              className="LandProductDetailImage"
              src={this.state.product.picture}
            />
          </div>

          {this.state.product.document ? (
            <div className="LandProductDetailDocumentWrapper">
              <div className="LandProductDetailDocumentTitle">产品说明</div>
              {this.state.product.document.map((paragraph) =>
                paragraph.type == 'text' ? (
                  <div className="LandProductDetailDocumentText">
                    {paragraph.content}
                  </div>
                ) : (
                  <ConfigProvider locale={zhCN}>
                    <Image
                      width={500}
                      style={{
                        textAlign: 'start',
                        marginBottom: 30,
                        cursor: 'pointer',
                      }}
                      src={paragraph.src}
                      preview={{ src: paragraph.src, mask: null }}
                    />
                  </ConfigProvider>
                )
              )}
            </div>
          ) : null}
        </div>

        <Drawer
          width={400}
          title={this.state.variety ? this.state.variety.name : '全部产品'}
          placement="right"
          open={this.state.open}
          loading={this.state.loading}
          onClose={() => {
            this.setState({ open: false })
          }}
        >
          <div id="productList">
            <InfiniteScroll
              dataLength={this.state.dataSource.length}
              scrollableTarget="productList"
            >
              <List
                dataSource={this.state.dataSource}
                renderItem={(item) => (
                  <List.Item
                    key={item.pid}
                    ref={this.getProductRefByPid(item.pid)}
                    className={
                      item.pid == this.state.product.pid
                        ? 'LandProductDetailListItemSel'
                        : 'LandProductDetailListItemNor'
                    }
                    onClick={() => {
                      this.selectProduct(item)
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        <img
                          className="LandProductDetailListItemImage"
                          src={item.picture}
                        />
                      }
                      title={
                        <div className="LandProductDetailListItemName">
                          {item.name}
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </div>
        </Drawer>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }

  getCommonLinkButton = () => {
    return (
      <Button
        type="primary"
        size="large"
        style={{ marginTop: '40px', fontFamily: 'MyCustomizedFont' }}
        onClick={this.gotoShop}
      >
        立即购买
      </Button>
    )
  }

  getCommonConsultButton = () => {
    return (
      <Button
        color="pink"
        variant="filled"
        size="large"
        style={{ marginTop: '40px', fontFamily: 'MyCustomizedFont' }}
        onClick={this.viewContact}
      >
        咨询购买
      </Button>
    )
  }

  selectProduct = (product) => {
    var item = this.getScrolledPositionItem(this.state.dataSource, product)
    if (item) {
      var ref = this.getProductRefByPid(item.pid)
      if (ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth' })
      }
    }
    this.setState({
      pid: product.pid,
      product: product,
    })
  }

  geInitialStateParams = (search) => {
    var i = search.indexOf('pid=')
    var pid = parseInt(search.substring(i + 4, search.length))
    var product = getProductByPid(pid)
    var j = search.indexOf('vid=')
    var vid = j >= 0 ? parseInt(search.substring(j + 4, search.length)) : -1
    var variety = getVarietyByVid(vid)
    var dataSource = variety ? getProductsOfVariety(variety.vid, 0) : products
    var initialPositionItem = this.getScrolledPositionItem(dataSource, product)
    return [pid, product, vid, variety, dataSource, initialPositionItem]
  }

  getScrolledPositionItem = (dataSource, product) => {
    if (!dataSource || dataSource.length == 0 || !product) {
      return null
    }
    if (dataSource[0].pid == product.pid) {
      return dataSource[0]
    }
    for (var i = 0; i < dataSource.length - 1; i++) {
      if (dataSource[i + 1].pid == product.pid) {
        return dataSource[i]
      }
    }
    return null
  }

  getProductRefs = () => {
    var refs = {}
    if (this.state.dataSource) {
      for (var product of this.state.dataSource) {
        refs[product.pid] = React.createRef()
      }
    }
    return refs
  }

  getProductRefByPid = (pid) => {
    return this.productRefs[pid]
  }

  viewContact = () => {
    this.props.history.push('/contact')
  }

  gotoShop = () => {
    window.open(this.state.product.link, '_blank')
  }
}
